:host {
  display: inline-flex;
}
.breadcrumb-item {
  display: inline-flex;
  align-items: center;
  font-family: var(--sc-font-sans);
  font-size: var(--sc-font-size-small);
  font-weight: var(--sc-font-weight-semibold);
  color: var(--sc-breadcrumb-color, var(--sc-color-gray-600));
  line-height: var(--sc-line-height-normal);
  white-space: nowrap;
}
.breadcrumb-item__label {
  display: inline-block;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  line-height: inherit;
  text-decoration: none;
  color: inherit;
  background: none;
  border: none;
  border-radius: var(--sc-border-radius-medium);
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: color var(--sc-transition-fast) ease;
}
:host(:not(:last-of-type)) .breadcrumb-item__label {
  color: var(--sc-breadcrumb-item-label-color, var(--sc-color-gray-900));
}
:host(:not(:last-of-type)) .breadcrumb-item__label:hover {
  color: var(--sc-breadcrumb-item-label-hover-color, var(--sc-color-primary-500));
}
:host(:not(:last-of-type)) .breadcrumb-item__label:active {
  color: var(--sc-breadcrumb-item-label-active-color, var(--sc-color-gray-900));
}
.breadcrumb-item__label:focus {
  box-shadow: var(--sc-focus-ring);
}
.breadcrumb-item__prefix,
.breadcrumb-item__suffix {
  display: none;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
}
.breadcrumb-item--has-prefix .breadcrumb-item__prefix {
  display: inline-flex;
  margin-right: var(--sc-spacing-x-small);
}
.breadcrumb-item--has-suffix .breadcrumb-item__suffix {
  display: inline-flex;
  margin-left: var(--sc-spacing-x-small);
}
:host(:last-of-type) .breadcrumb-item__separator {
  display: none;
}
.breadcrumb-item__separator {
  display: inline-flex;
  align-items: center;
  margin: 0 var(--sc-spacing-x-small);
  user-select: none;
}
